import { UnsubscribeStatuses } from '../Constants';
import text from 'I18n/utils/unescapedText';
const createAlert = (email, status) => ({
  id: status,
  titleText: text(`alerts.${status}.title`),
  message: text(`alerts.${status}.message`, {
    email
  }),
  timestamp: Date.now(),
  closeable: false
});
export const getAlert = (status, {
  email
}) => {
  switch (status) {
    case UnsubscribeStatuses.SUCCESS:
    case UnsubscribeStatuses.SUCCESS_UNSUB_ALL:
      return [Object.assign({}, createAlert(email, status), {
        type: 'success'
      })];
    case UnsubscribeStatuses.WRONG_EMAIL:
      return [Object.assign({}, createAlert(email, status), {
        type: 'danger'
      })];
    default:
      {
        return [];
      }
  }
};
export const sanitizeEmail = email => {
  const splitEmail = email.split('"+<');
  if (splitEmail.length === 1) {
    return email;
  }
  const cleanedName = splitEmail[0].split('+').join(' ');
  return `${cleanedName}" <${splitEmail[1]}`;
};
export const parseApiError = error => {
  if (!error || !error.responseJSON || !error.responseJSON.message) {
    return {
      isWrongEmail: false,
      isInvalidProduct: false,
      isUserError: false
    };
  }
  const isWrongEmail = /Provided email was not a recipient of the original send/.test(error.responseJSON.message);
  const isInvalidProduct = /Trying to get subscriptions using an unsupported product./.test(error.responseJSON.message);
  const isUserError = /Request was not in a valid format/.test(error.responseJSON.message);
  return {
    isWrongEmail,
    isInvalidProduct,
    isUserError
  };
};